import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LanguageModel } from 'src/app/interfaces/language/Language.model';
import { TranslationHelperService } from 'src/app/services/translation-helper/translation-helper.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-switch-language-dialog',
  templateUrl: './switch-language-dialog.component.html',
  styleUrls: ['./switch-language-dialog.component.scss']
})
export class SwitchLanguageDialogComponent implements OnInit {

  activeStep: number = 1;

  venueId: string = '';
  venueMaxCapacity: number = 0;

  labelForReservationCapacityLimit = "Change Language";
  languages: LanguageModel[];
  selectedOptions: LanguageModel = {
    id:null,
    name: '',
    translateValue: '',
    icon: ''
  };

  constructor(
    private dialogRef: MatDialogRef<SwitchLanguageDialogComponent>,
    private translationHelperService: TranslationHelperService,
    private authService: AuthService,
  ) {
    this.languages = [
      {id:1,name: 'LANGUAGE.ENGLISH', translateValue: 'en', icon:'&#127482;&#127480;'},
      {id:2,name: 'LANGUAGE.MACEDONIAN', translateValue: 'mk', icon:'&#127474;&#127472;'},
    ]
   }

  ngOnInit(): void {
  }

  onAreaListControlChanged(language: LanguageModel){
    this.selectedOptions = language;
    this.switchActiveLang(language.translateValue , language.id);
    this.close();
  }

  switchActiveLang(language: string,languageId:null|number): void {
    this.translationHelperService.setActiveLanguage(language ,languageId);
    this.authService.changeLangPrivacyPolicyEventEmitter.emit(true);
  }

  close() {
    this.dialogRef.close();
  }

}
